// Canonical demand stage vocabulary — mirrors STAGE_SEQUENCE / STAGE_ALIASES in
// backend/AIEA/backend/apis/demand_stages.py.
//
// This exists because the mapping used to live inline in DemandDashboard.js and was
// incomplete: DISCOVERY_COMPLETE, TRIAGE_RETURNED, REJECTED and COMPLETED were all
// missing, and the lookup ended `|| 'triage'` — so a demand that had just finished
// Discovery silently reappeared in the Triage column, which is exactly what "phase 2
// doesn't work all the way" looked like from the dashboard.
//
// Any value the backend can write must appear here.

export const STAGE_SEQUENCE = [
  "TRIAGE", "DISCOVERY", "POC", "REQUIREMENTS", "SECURITY", "TAB", "EXECUTION",
];

/** Stored current_stage -> the canonical stage it belongs to. */
export const STAGE_ALIASES = {
  TRIAGE_PENDING: "TRIAGE",
  TRIAGE_RETURNED: "TRIAGE",
  TRIAGE_FAILED: "TRIAGE",
  TRIAGE_PASSED: "DISCOVERY",
  DISCOVERY_COMPLETE: "DISCOVERY",
  ENHANCED_DISCOVERY: "POC",      // legacy
  AI_REQUIREMENTS: "REQUIREMENTS", // legacy
};

export const TERMINAL_STAGES = ["REJECTED", "COMPLETED"];

/** Canonical stage -> the UI id used by the dashboard columns and the routes. */
export const STAGE_UI_ID = {
  TRIAGE: "triage",
  DISCOVERY: "discovery",
  POC: "poc",
  REQUIREMENTS: "requirements",
  SECURITY: "security",
  TAB: "tab",
  EXECUTION: "execution",
};

export const STAGE_LABEL = {
  TRIAGE: "Triage",
  DISCOVERY: "Discovery",
  POC: "Enhanced Discovery (POC)",
  REQUIREMENTS: "AI Requirements",
  SECURITY: "Security Pre-Screen",
  TAB: "TAB Decision",
  EXECUTION: "Execution Handoff",
  REJECTED: "Rejected",
  COMPLETED: "Completed",
};

/** Any stored stage value -> canonical stage (or a terminal value). */
export function canonicalStage(stage) {
  const value = String(stage || "TRIAGE_PENDING").toUpperCase();
  if (TERMINAL_STAGES.includes(value)) return value;
  const resolved = STAGE_ALIASES[value] || value;
  return STAGE_SEQUENCE.includes(resolved) ? resolved : "TRIAGE";
}

/** Any stored stage value -> dashboard column id. Terminal stages have no column. */
export function stageUiId(stage) {
  const canonical = canonicalStage(stage);
  return STAGE_UI_ID[canonical] || null;
}

export function stageLabel(stage) {
  return STAGE_LABEL[canonicalStage(stage)] || stage || "Unknown";
}

/**
 * Does a demand belong on the screen for `uiId`?
 *
 * Matches on the canonical stage rather than a raw startsWith, so a demand in
 * DISCOVERY_COMPLETE still belongs to Discovery and one in TRIAGE_RETURNED still
 * belongs to Triage.
 */
export function belongsToStage(currentStage, uiId) {
  return stageUiId(currentStage) === uiId;
}
